import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Package, CheckCircle2 } from "lucide-react";
import api from "../lib/api";
import { formatMXN } from "../lib/format";
import { useAuth } from "../context/AuthContext";

export default function MyOrders() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    if (!loading && !user) navigate("/login");
  }, [user, loading]);

  useEffect(() => {
    if (user) api.get("/orders").then((res) => setOrders(res.data));
  }, [user]);

  return (
    <div className="mx-auto max-w-4xl px-6 py-12">
      <h1 className="font-display text-3xl font-extrabold text-brand-navy">Mis pedidos</h1>
      {orders.length === 0 ? (
        <div className="mt-10 flex flex-col items-center gap-3 py-16 text-slate-400">
          <Package className="h-12 w-12" />
          <p>Aún no tienes pedidos.</p>
          <button onClick={() => navigate("/")} className="rounded-full brand-navy px-5 py-2.5 text-sm font-bold text-white">
            Ver catálogo
          </button>
        </div>
      ) : (
        <div className="mt-8 space-y-4">
          {orders.map((o) => (
            <div key={o.id} className="rounded-2xl border border-slate-200 bg-white p-5">
              <div className="flex items-center justify-between">
                <span className="font-mono-data text-xs text-slate-400">#{o.id.slice(-8)}</span>
                <span className={`flex items-center gap-1 rounded-full px-3 py-1 text-xs font-bold ${o.status === "paid" ? "bg-emerald-50 text-brand-forest" : "bg-slate-100 text-slate-500"}`}>
                  {o.status === "paid" && <CheckCircle2 className="h-3.5 w-3.5" />}
                  {o.status === "paid" ? "Pagado" : o.status}
                </span>
              </div>
              <div className="mt-3 space-y-1">
                {o.items.map((i, idx) => (
                  <p key={idx} className="text-sm text-slate-600">{i.quantity}× {i.title}</p>
                ))}
              </div>
              <div className="mt-3 border-t border-slate-100 pt-3 text-right font-display font-extrabold text-brand-navy">
                {formatMXN(o.total)}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
